/** @jsxImportSource @emotion/react */

import tw from "twin.macro";
import { LogoProps } from "./Logo.d";

const VerticalLogo: React.FC<LogoProps> = ({ withText, wrapperCss }) => {
  return (
    <div css={[tw`m-auto`, wrapperCss]}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox={withText ? "0 0 474 290.44" : "0 0 474 190.44"}
      >
        <g css={[tw`block`, !withText && tw`hidden`]}>
          <path
            fill="#010101"
            d="M0 289.76v-74h43v6H6v27h35v6H6v35H0ZM86.69 290.44c-18.74 0-32.55-15.37-32.55-37.95s13.81-37.95 32.55-37.95 32.67 15.37 32.67 37.95-13.81 37.95-32.67 37.95Zm0-70.14c-15.61 0-26.3 13.21-26.3 32.19s10.69 32.19 26.3 32.19 26.42-13.21 26.42-32.19-10.69-32.19-26.42-32.19ZM142 256.76v33h-6v-74h25.53c14.12 0 22.71 7.23 22.71 20.73 0 12.05-6.94 18.92-18.35 20.37l21.77 32.9h-5.59l-22.16-33h-17.9Zm0-5h19.52c11.19 0 17.26-5.6 17.26-15s-6.07-15-17.26-15H142v30ZM250 215.76v6h-40v27h36v6h-36v29h40v6h-46v-74h46Z"
          />
          <path
            fill="#1a67b2"
            d="M268.55 270.76c2.98 8.82 10.72 13.46 20.73 13.46s18.23-5.36 18.23-14.65c0-6.43-3.34-10.96-12.63-13.58l-13.94-3.93c-10.24-2.86-16.8-7.5-16.8-17.87 0-12.39 10.48-19.77 23.11-19.77 14.29 0 22.87 7.5 25.73 18.34h-6.08c-2.74-7.74-9.05-12.86-19.66-12.86-9.53 0-17.27 5-17.27 13.94 0 7.74 5 10.48 13.94 12.98l12.27 3.57c12.03 3.34 17.27 9.29 17.27 18.94 0 12.86-10.48 20.37-24.18 20.37s-24.18-6.79-27.04-18.94h6.31ZM337 289.76h-6v-74h6v74ZM352 215.76h60v6h-27v68h-6v-68h-27v-6ZM474 215.76v6h-40v27h36v6h-36v29h40v6h-46v-74h46Z"
          />
        </g>

        <g>
          <ellipse fill="#d2d3d4" cx="236.5" cy="162.26" rx="65.5" ry="19.5" />
          <ellipse fill="#bdbec0" cx="236.5" cy="161.26" rx="42.5" ry="12.5" />
          <path
            fill="#1a67b2"
            d="M283.67 27.23C273.98 10.43 255.9 0 236.48 0c-9.51 0-18.91 2.53-27.18 7.31-12.59 7.27-21.6 19.01-25.37 33.05-3.77 14.05-1.83 28.72 5.44 41.31l45.29 78.45c.39.67 1.1 1.08 1.87 1.08s1.48-.41 1.87-1.08l45.29-78.44c9.68-16.8 9.68-37.67-.02-54.45Zm-24.55 28.61c0 12.46-10.14 22.59-22.59 22.59s-22.59-10.14-22.59-22.59 10.14-22.59 22.59-22.59 22.59 10.14 22.59 22.59Z"
          />
        </g>
      </svg>
    </div>
  );
};

export default VerticalLogo;
